import errorStateImage from 'assets/icon-pivot.png';
import { WebCommonAssets } from './types/assets.types';

export const WEB_COMMON_ASSETS_MAP: WebCommonAssets = {
  WEB_COMMON_ERROR_STATE_IMAGE: errorStateImage,
};
